export default function HistoryIcon({
    style,
    fill="#E8E8E8",
}){
    return 	<svg style={style} width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M7 19.6356C9.14985 22.869 12.8261 25 17 25C23.6274 25 29 19.6274 29 13C29 6.37258 23.6274 1 17 1C10.7093 1 5.54923 5.84047 5.04108 12" stroke={fill} strokeWidth="1.5" strokeLinecap="round"/>
				<path d="M3 12L5 13.5L7 12" stroke={fill} strokeWidth="1.5" strokeLinecap="round"/>
				<path d="M17 7V14L22 18" stroke={fill} strokeWidth="1.5" strokeLinecap="round"/>
			</svg>
}
